import _ from 'lodash';
import React from 'react';
import styles from './GameHeader.module.scss';
import posed from 'react-pose';
import {keysToSingleValue} from '../utils/objectFactory';
import makeNimbus from './Nimbus';
import {isDraw} from '../gameHelpers';

const headerPoses = [
    'header-initial',
    'header-normal',
    'header-listen',
    'header-analyze',
    'header-result',
];

const delay = 1000;
const duration = 1000;

const Anchor = posed.div({});

const appearFromUp = enterPose => ({
    [enterPose]: {
        y: props => (props.up ? getHeaderInvisibleOffset(props) : 0),
        opacity: 1,
        delay,
        transition: {
            y: {ease: 'easeOut', duration},
            opacity: {duration: 0},
        },
    },
    ...keysToSingleValue(_.without(headerPoses, enterPose), {
        y: props => getHeaderInvisibleOffset(props),
        opacity: 0,
        delay,
        transition: {ease: 'easeIn', duration},
    }),
});

function getHeaderInvisibleOffset(props) {
    return props.tall ? '-15em' : '-7em';
}

const NormalHeader = posed.div(appearFromUp('header-normal'));
const ListenHeader = posed.div(appearFromUp('header-listen'));
const AnalyzeHeader = posed.div(appearFromUp('header-analyze'));
const ResultHeader = posed.div(appearFromUp('header-result'));

const DrawNimbus = makeNimbus({
    pose: 'header-result',
    delay: 1000,
    duration: 1000,
});

export default function GameHeader({game}) {
    const pose = formPose(game);

    return (
        <Anchor
            pose={pose}
            initialPose='header-initial'
            poseKey={game.try}
            className={styles.headerAnchor}
        >
            {renderTwoNormalHeaders(game)}
            <ListenHeader>
                <div className={styles.header}>Listen</div>
            </ListenHeader>
            <AnalyzeHeader>
                <div className={styles.header}>Analyze</div>
            </AnalyzeHeader>
            <ResultHeader tall>
                <div className={styles.header}>
                    <div className={styles.resultHeader}>
                        <div>Good job everyone!</div>
                        <div>Good luck with the rest of your journey!</div>
                    </div>

                    {isDraw(game) && (
                        <DrawNimbus
                            className={styles.drawNimbus}
                            count={5}
                            angle1={90 - 40}
                            angle2={90 + 40}
                            direction={1}
                            radius1={0.775}
                            radius2={0.9}
                            strokeWidth={22}
                            strokeLinecap='round'
                        />
                    )}
                </div>
            </ResultHeader>
        </Anchor>
    );
}

function formPose(game) {
    const {playingAudio, stage} = game;

    if (stage === 'discussion-wait' && playingAudio) {
        return 'header-listen';
    }

    if (stage === 'discussion-analyze') {
        return 'header-analyze';
    }

    if (stage === 'result') {
        return 'header-result';
    }

    return 'header-normal';
}

function renderTwoNormalHeaders(game) {
    const {round, try: tryIndex} = game;

    return _.range(2)
        .map(index => {
            const up = (index + tryIndex) % 2 !== 0;

            return {
                up,
                round,
                tryIndex: up ? tryIndex - 1 : tryIndex,
            };
        })
        .map(renderNormalHeader);
}

function renderNormalHeader({up, round, tryIndex}, index) {
    return (
        <NormalHeader key={index} up={up}>
            <div className={styles.header}>
                <div className={styles.stats}>Round: {round + 1}</div>
                <div className={styles.spacer} />
                <div className={styles.stats}>Tries: {tryIndex + 1}</div>
            </div>
        </NormalHeader>
    );
}
